import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {ButtonStyle} from 'ui-library/buttons/Button';
import Modal from 'ui-library/modals/Modal';

/**
 * Props for the ConfirmCancelModal component.
 *
 * @prop userFacingContextName - The name displayed in the modal to refer to the context that the user is
 * leaving.
 */
interface ConfirmCancelModalProps {
  userFacingContextName: string;
  onRequestSubmit: (result: {}) => void;
  onRequestClose: () => void;
}

/**
 * Renders a modal that allows the user to confirm that they want to leave a context without saving, or return
 * to the context.
 */
export default function ConfirmCancelModal(props: ConfirmCancelModalProps): JSX.Element {
  return (
    <Modal
      title={`Leave ${props.userFacingContextName}?`}
      buttons={[
        {
          text: 'Leave without saving',
          submit: true,
          style: ButtonStyle.TERTIARY_GRAY,
        },
        {
          text: `Go back to ${props.userFacingContextName}`,
          submit: false,
          style: ButtonStyle.PRIMARY,
          onClick: () => {
            props.onRequestClose();
          },
        },
      ]}
      onRequestSubmit={() => {
        props.onRequestSubmit({});
      }}
      onRequestClose={props.onRequestClose}
    >
      <p className={css(styles.modalBody)}>If you leave, any changes you've made will not be saved.</p>
    </Modal>
  );
}

const styles = StyleSheet.create({
  modalBody: {
    fontSize: '14px',
  },
});
